export default {
  namespaced: true,
  state: {
    selectedServiceOrder: null
  },
  mutations: {
    setSelectedServiceOrder(state, serviceOrder) {
      state.selectedServiceOrder = serviceOrder;
    },
    clearSelectedServiceOrder(state) {
      state.selectedServiceOrder = null;
    }
  },
  getters: {
    getSelectedServiceOrder: state => state.selectedServiceOrder
  }
}; 